import { Link } from "react-router-dom";
import poussette from '../styles/images/poussette.jpg';
import velo from '../styles/images/moto-futur.png';
import voiture from '../styles/images/voiture.jpg';
import armure from '../styles/images/armure-logo.png';
import fusee from '../styles/images/mirage.jpg';
import '../styles/css/Recompenses.css';

const ROUGE = '#9E2430';
const TEAL  = 'rgb(37, 190, 136)';

const CarteRecompense = ({ image, niveau, points, avantages }) => (
  <div style={{
    borderRadius: '12px', overflow: 'hidden',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    background: '#fff', height: '100%',
    display: 'flex', flexDirection: 'column',
  }}>
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <img
        src={image} alt={niveau}
        style={{
          width: '100%', height: '400px',
          objectFit: 'cover', display: 'block',
        }}
      />
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <span className="level-title" style={{
          color: '#fff', fontWeight: 700, fontSize: '1.3rem',
          textTransform: 'uppercase', textAlign: 'center',
          letterSpacing: '1px',
        }}>
          {niveau}
        </span>
      </div>
    </div>

    <div style={{
      background: '#f8f9fa', borderTop: '1px solid #dee2e6',
      padding: '10px 12px', flex: 1,
    }}>
      <div style={{
        background: '#e9ecef', borderRadius: '6px',
        padding: '5px 10px', textAlign: 'center',
        fontWeight: 700, fontSize: '0.88rem', color: '#333',
        marginBottom: '8px',
      }}>
        {points} points
      </div>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }} >
        {avantages.map((a, i) => (
          <li key={i} style={{
            padding: '3px 0', fontSize: '0.78rem',
            borderBottom: i < avantages.length - 1 ? '1px solid #dee2e6' : 'none',
          }}>
            <span className="text-muted" style={{ color: ROUGE, fontWeight: 700 }}>{a.label}</span>
            {a.suite && <span style={{ color: '#555' }}> {a.suite}</span>}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default function Recompenses() {

  const niveaux = [
    {
      image: poussette, niveau: "Rookie", points: "10 000",
      avantages: [
        { label: "-15%", suite: "sur l'abonnement mensuel premium" },
        { label: "-10%", suite: "sur l'abonnement annuel" },
      ]
    },
    {
      image: velo, niveau: "Rider", points: "20 000",
      avantages: [
        { label: "-20%", suite: "sur l'abonnement mensuel premium" },
        { label: "-15%", suite: "sur l'abonnement annuel" },
      ]
    },
    {
      image: voiture, niveau: "Roadster", points: "30 000",
      avantages: [
        { label: "-25%", suite: "sur l'abonnement mensuel premium" },
        { label: "-20%", suite: "sur l'abonnement annuel" },
      ]
    },
    {
      image: fusee, niveau: "Phantom", points: "40 000",
      avantages: [
        { label: "-30%", suite: "sur l'abonnement mensuel premium" },
        { label: "-25%", suite: "sur l'abonnement annuel" },
      ]
    },
    {
      image: armure, niveau: "Legend", points: "50 000",
      avantages: [
        { label: "-35%", suite: "sur l'abonnement mensuel premium" },
        { label: "-30%", suite: "sur l'abonnement annuel" },
      ]
    },
  ];

  const pointsActions = [
    { action: "Signaler la libération de sa place *",    points: "5 points" },
    { action: "Obtenir des étoiles entre utilisateurs | Bientôt disponible",       points: "1 étoile = 1 point" },
    { action: "Vendre ou acheter une place libre ** | Bientôt disponible",         points: "150 points" },
    { action: "Souscrire à un abonnement mensuel | Bientôt disponible",            points: "100 points (1 200/an)" },
    { action: "Souscrire à un abonnement annuel | Bientôt disponible",             points: "1 500 points " },
    { action: "Parrainer une personne",                       points: "250 pts *** + 3 mois offerts ****" },
  ];

  return (
    <div style={{ paddingBottom: '40px' }}>

      {/* ── En-tête ──────────────────────────────────────────────────────── */}
      <div className="container px-3 px-md-4">
        <h3 style={{
          textAlign: 'center', textTransform: 'uppercase',
          padding: '16px 0 8px', marginBottom: '8px',
          fontSize: 'clamp(1rem, 4vw, 1.4rem)', fontWeight: 700,
        }}>
          Pour accéder aux récompenses :
        </h3>
        <ol style={{ fontSize: '0.95rem', paddingLeft: '20px', marginBottom: '24px' }}>
          <li style={{ marginBottom: '4px' }}>Créer un compte</li>
          <li>Pour obtenir plus de points, souscrire à un abonnement {''} <badge className="bg-warning text-dark p-1 rounded">Bientôt disponible</badge></li>
        </ol>

        {/* ── Grille niveaux — CSS uniquement, pas de style inline ─────── */}
        <div className="grille-niveaux">
          {niveaux.map((n) => (
            <CarteRecompense key={n.niveau} {...n} />
          ))}
        </div>
      </div>

      {/* ── Bouton inscription ────────────────────────────────────────────── */}
      <div style={{ display: 'flex', justifyContent: 'center', padding: '0 16px 32px' }}>
        <Link
          to="/inscription"
          className="btn btn-primary"
          style={{
            fontSize: 'clamp(1rem, 4vw, 1.2rem)',
            padding: '12px 40px', borderRadius: '10px',
            fontWeight: 700, width: '100%',
            maxWidth: '320px', textAlign: 'center',
          }}>
          S'inscrire gratuitement
        </Link>
      </div>

      {/* ── Bandeau "Obtenir des points" ──────────────────────────────────── */}
      <div style={{
        background: TEAL, margin: '0 0 40px', padding: '40px 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <h2 style={{
          color: '#fff', textAlign: 'center',
          fontSize: 'clamp(1.1rem, 5vw, 1.8rem)',
          fontWeight: 700, margin: 0,
        }}>
          Obtenir des points de niveaux <i className="fa-solid fa-fire"></i>
        </h2>
      </div>

      {/* ── Tableau des points ────────────────────────────────────────────── */}
      <div className="container px-3 px-md-4 mb-4" id="points">

        {/* Version mobile — cards */}
        <div className="d-md-none">
          <h5 style={{
            textAlign: 'center', textTransform: 'uppercase',
            fontWeight: 700, marginBottom: '16px', fontSize: '0.95rem',
          }}>
            Comment obtenir des points ?
          </h5>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {pointsActions.map((item, i) => (
              <div key={i} style={{
                display: 'flex', justifyContent: 'space-between',
                alignItems: 'center',
                background: i % 2 === 0 ? '#f8f9fa' : '#fff',
                border: '1px solid #dee2e6', borderRadius: '8px',
                padding: '12px 14px', gap: '12px',
              }}>
                <span style={{ fontSize: '0.85rem', color: '#333', flex: 1 }}>
                  {item.action}
                </span>
                <span style={{
                  fontSize: '0.85rem', fontWeight: 700,
                  color: TEAL, flexShrink: 0, textAlign: 'right',
                }}>
                  {item.points}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Version desktop — tableau */}
        <div className="d-none d-md-block">
          <table className="table table-striped" style={{ fontSize: '1.1rem' }}>
            <thead>
              <tr>
                <th colSpan="2" style={{
                  textAlign: 'center', textTransform: 'uppercase',
                  fontWeight: 700, border: '1px solid #dee2e6',
                }}>
                  Comment obtenir des points ?
                </th>
              </tr>
            </thead>
            <tbody>
              {pointsActions.map((item, i) => (
                <tr key={i}>
                  <th style={{ fontWeight: 600 }}>{item.action}</th>
                  <td>{item.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Notes bas de page */}
        <div style={{
          fontSize: '0.78rem', color: '#666', lineHeight: 1.6,
          marginTop: '12px', padding: '12px', background: '#f8f9fa',
          borderRadius: '8px', border: '1px solid #dee2e6',
        }}>
          * Limité à 10 signalements par jour<br />
          ** Sous réserve de validation de la transaction<br />
          *** Sous réserve que la personne parrainée crée un compte{' '}
          <strong style={{ color: TEAL }}>SpotyPark</strong> via votre lien de parrainage<br />
          **** Sous réserve de souscription à un abonnement annuel par votre filleul {' '}
          {/* <strong style={{ color: TEAL }}>SpotyZen</strong> */}
        </div>
      </div>

    </div>
  );
}